var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    data-toggle=\"tooltip\" data-placement=\"top\" title=\""
    + container.escapeExpression(__default(require("../../helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":3,"column":54},"end":{"line":3,"column":65}}}))
    + "\"\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "    <i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label class=\"col-sm-6 control-label\"\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":4,"column":9}}})) != null ? stack1 : "")
    + ">"
    + alias2(__default(require("../../helpers/t.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"displayName") : depth0),{"name":"t","hash":{},"data":data,"loc":{"start":{"line":5,"column":1},"end":{"line":5,"column":18}}}))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":2},"end":{"line":8,"column":9}}})) != null ? stack1 : "")
    + "</label>\n<div class=\"col-sm-6\">\n  <input value=\"\"\n    data-type=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "\"\n    data-provide=\"slider\"\n    data-slider-min=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"min") : depth0), depth0))
    + "\"\n    data-slider-max=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"max") : depth0), depth0))
    + "\"\n    data-slider-step=\""
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"step") : depth0), depth0))
    + "\"\n    data-slider-value=\"["
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"low") : depth0), depth0))
    + ","
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"high") : depth0), depth0))
    + "]\"\n    data-slider-tooltip=\"\"\n    />\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/filters/ExtraParameterRangeView.hbs
// module id = 2072
// module chunks = 0